import { graphql } from '@/gql';
import type { ServiceAccountsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

type DownloadServiceAccountsInput = Omit<ServiceAccountsQueryVariables, 'pagination'>;

export const downloadServiceAccounts = async ({
  email,
  service,
  isActive,
  isClosed,
  isAutomatedAccount,
  isManualAccount,
  orderBy,
  sortType,
}: DownloadServiceAccountsInput): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query DownloadServiceAccounts(
        $email: String
        $service: String
        $isActive: Boolean
        $isClosed: Boolean
        $isAutomatedAccount: Boolean
        $isManualAccount: Boolean
        $orderBy: String
        $sortType: String
      ) {
        downloadServiceAccounts(
          email: $email
          service: $service
          isActive: $isActive
          isClosed: $isClosed
          isAutomatedAccount: $isAutomatedAccount
          isManualAccount: $isManualAccount
          orderBy: $orderBy
          sortType: $sortType
        )
      }
    `),
    variables: {
      email,
      service,
      isActive,
      isClosed,
      isAutomatedAccount,
      isManualAccount,
      orderBy,
      sortType,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.downloadServiceAccounts ?? '';
};
